import { BaseConfig } from '../ServiceConfig';

export interface ApprovalConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.ApprovalServiceConfigData';
  url: string;
}

export const ApprovalConfigurationFields: (keyof ApprovalConfiguration)[] = [
  'url',
];

export const BlankApprovalConfiguration: ApprovalConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.ApprovalServiceConfigData',
} as ApprovalConfiguration;
